export const DEFAULT_INCOME_TAXONOMY_URL='https://taxonomy.roenpro.com/incomeTaxonomy.json';
export const DEFAULT_EXPENSE_TAXONOMY_URL='https://taxonomy.roenpro.com/expenseTaxonomy.json';
